import { currentDevice } from '../../core/utils/currentDevice'

if (currentDevice.isMobile) {
  import('./code_applied_mobile.scss')
} else {
  import(`./code_applied.scss`)
}

function showCodeApplied(container) {
  const popup = container.querySelector('.js-code-applied')
  if (!popup) return

  popup.classList.add('is-active')

  const hide = () => {
    popup.classList.remove('is-active')
    window.removeEventListener('scroll', hide)
  }

  window.addEventListener('scroll', hide, { once: true })

  const cta = popup.querySelector('.js-open-fastbooking')
  if (cta) {
    cta.addEventListener('click', hide, { once: true })
  }
}

export { showCodeApplied }
